import { createContext, useContext } from "react";

export interface IChatLauncherContext {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const ChatLauncherContext = createContext<IChatLauncherContext>({} as IChatLauncherContext);

export const useChatLauncherContext = (): IChatLauncherContext => {
  return useContext(ChatLauncherContext);
};

export default ChatLauncherContext;
